import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { TextInput } from 'rcd-cpp-ui/ui/form/TextInput';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { getFieldValue } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';

export const NumberField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, updateData } = updater;
  const isMyItemsView = useSelector(s => s.view?.selected?.isMyItemsView);

  const value = getFieldValue(field, data);
  const shouldMask = !!isMyItemsView && field?.key == `Item.itemId`;

  const getNumberValue = (e: any) => {
    return e.target.value === '' ? null : e.target.value;
  };

  return (
    <FieldGroup {...props} value={value === 0 ? '0' : value}>
      <TextInput
        type="number"
        className={`form-control ${!!shouldMask ? 'fs-mask' : ''}`}
        value={value === 0 ? '0' : value || ''}
        min={field?.minValue}
        onBlur={(e: any) => {
          updateData(field, getNumberValue(e));
        }}
        onChange={(e: any) => {
          updateField(field, getNumberValue(e));
        }}
      />
    </FieldGroup>
  );
};
